// Accordion.tsx
import React, { useState } from 'react';
import './Accordion.css';

// Define the types for our props
interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
  isOpen: boolean;
  toggleAccordion: () => void;
}

interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}

const AccordionItem: React.FC<AccordionItemProps> = ({ 
  title, 
  content, 
  isOpen, 
  toggleAccordion 
}) => {
  return (
    <div className="accordion-item">
      <div 
        className="accordion-header"
        onClick={toggleAccordion}
      >
        <h3 className="accordion-title">{title}</h3>
        <button className={`accordion-toggle-button ${isOpen ? 'open' : ''}`}>
          {isOpen ? (
            <svg className="accordion-icon" viewBox="0 0 24 24">
              <path d="M20 12H4" />
            </svg>
          ) : (
            <svg className="accordion-icon" viewBox="0 0 24 24">
              <path d="M12 4v16M4 12h16" />
            </svg>
          )}
        </button>
      </div>
      {isOpen && (
        <div className="accordion-content">
          {content}
        </div>
      )}
    </div>
  );
};

const Accordion: React.FC<AccordionProps> = ({ items }) => {
  const [openItems, setOpenItems] = useState<Set<number>>(new Set([0])); // First item open by default

  const toggleAccordion = (index: number): void => {
    setOpenItems(prevOpenItems => {
      const newOpenItems = new Set(prevOpenItems);
      if (newOpenItems.has(index)) {
        newOpenItems.delete(index);
      } else {
        newOpenItems.add(index);
      }
      return newOpenItems;
    });
  };

  return (
    <div className="accordion-container">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          content={item.content}
          isOpen={openItems.has(index)}
          toggleAccordion={() => toggleAccordion(index)}
        />
      ))}
    </div>
  );
};

export default Accordion;